import { Shark, Utils, View } from "shark-mvc";
import { Collapse } from "bootstrap";
import Sortable from "sortablejs";

import Activity from "../../models/Activity";
import Project from "../../models/Project";
import Task from "../../models/Task";

import templateContent from "./activity-list.html";
import "./style.css";

import activityManager from "../../controllers/activityManager";
import activitySettingsComponent from "../../components/activity-settings/activitySettingsComponent";
import mainNavComponent from "../../components/main-nav/mainNavComponent";
import projectManager from "../../controllers/projectManager";
import taskListView from "../task/taskListView";
import taskManager from "../../controllers/taskManager";
import taskModalComponent from "../../components/taskModal/taskModalComponent";
import userManager from "../../controllers/userManager";
import userPermissionManager from "../../controllers/userPermissionManager";
import waitBoxComponent from "../../components/wait-box/waitBoxComponent";

class ActivityListView extends View {
	constructor () {
		super("activityListView");

		this.setTemplate(templateContent);

		this.$documentTitle = "Attività | PRJM";
	}

	activityBtn_clickHandler (event, data) {
		if (event.target.closest(".preventRowClick")) {
			return;
		}
		const currActivity = Utils.safp(Shark.$store.activityList, "guid", data.guid);

		if (currActivity) {
			Shark.set({ currActivity });
			Shark.openPage(taskListView, {urlSearchParams: { actguid: currActivity.guid } });
		}
	}

	afterLoad () {
		this.collapse = new Collapse(document.querySelector("#newActivityBox"), {
			toggle: false,
		});

		document.querySelectorAll(".hand-scroll").forEach(this.setHandScroll);
	}

	async beforeLoad () {
		// Shark.set({
		// 	__pageTitle: "Attività",
		// });

		await userManager.checkUserList();
		window.scrollTo(0, 0);
		waitBoxComponent.open();

		const urlParams = new URLSearchParams(document.location.search);

		if (!Shark.$store.currProject) {
			if (urlParams.has("prjguid")) {
				projectManager.getByGuid(urlParams.get("prjguid"))
				.then(getByGuidResponse => {
					const currProject = new Project(getByGuidResponse.data[0]);

					Shark.set({
						currProject,
					});

					this.refreshList(urlParams.get("prjguid"));
				});
			}
		}
		else {
			this.refreshList(Shark.$store.currProject.guid);
		}
	}

	cancelActivityEdits () {
		if (!Shark.$store?.currActivity?.isDirty() || confirm("Vuoi annllare?")) {
			Shark.$store.currActivity.restore();
			this.collapse?.hide();
		}
	}
	
	cancelActivityEditsBtn_clickHandler () {
		this.cancelActivityEdits();
	}

	closeActivity (guid) {
		const selectedActivity = Utils.safp(Shark.$store.activityList, "guid", guid);

		if (selectedActivity && confirm("Confermi di voler chiudere questa Attività?")) {
			activityManager.close(selectedActivity)
			.then(() => {
				this.refreshList();
			});
		}
	}

	closeActivityBtn_clickHandler (event, data) {
		this.closeActivity(data.guid);
	}

	createNewActivityBtn_clickHandler () {
		const currActivity = new Activity({
			projectGuid: Shark.$store?.currProject.guid,
			status: 1,
		});

		Shark.set({
			currActivity,
		});

		Shark.render();
		document.querySelector("#activityNameField")?.focus();
	}

	editActivity (guid) {
		const currActivity = Utils.safp(Shark.$store.activityList, "guid", guid);

		if (currActivity) {
			Shark.set({ currActivity });
			Shark.render();
			this.collapse.show();
		}
	}

	editActivityBtn_clickHandler (event, data) {
		this.editActivity(data.guid);
	}

	flashTaskInsertBox_mouseoutHandler (event) {
		if (event.originalEvent.relatedTarget.closest("[data-flash-task-insert-box]") === event.target.closest("[data-flash-task-insert-box]")) {
			return;
		}

		event.target.closest("[data-flash-task-insert-box]").classList.remove("open");
	}

	init () {
		this.addComponents([activitySettingsComponent, mainNavComponent, taskModalComponent, waitBoxComponent]);

		let activityViewFiltersData = Utils.parseJSON(localStorage.getItem("activityViewFilters"), "object");
		const displayMode = activityViewFiltersData ? activityViewFiltersData.displayMode : "list";

		const activityViewFilters = Shark.getInstance("__smart__", {
			showClosedActivities: activityViewFiltersData ? activityViewFiltersData.showClosedActivities : false,
			showOpenActivities: activityViewFiltersData ? activityViewFiltersData.showOpenActivities : true,
			showOnlyActivitiesWithMyTask: activityViewFiltersData ? activityViewFiltersData.showOnlyActivitiesWithMyTask : false,
			showActivitiesWithoutOpenTasks: activityViewFiltersData ? activityViewFiltersData.showActivitiesWithoutOpenTasks : false,
			
			showActiveActivities: activityViewFiltersData ? activityViewFiltersData.showActiveActivities : true,
			showCreatedActivities: activityViewFiltersData ? activityViewFiltersData.showCreatedActivities : true,

			displayMode,
			displayModeList: displayMode === "list",
			displayModeCards: displayMode === "cards",
		});

		activityViewFilters.onDataChanged = function () {
			localStorage.setItem("activityViewFilters", JSON.stringify(this.export()));

			this.displayModeList = this.displayMode === "list";
			this.displayModeCards = this.displayMode === "cards";

			activityListView.refreshList();
		};
		console.log({activityViewFilters, activityViewFiltersData});

		Shark.set({
			activityList: [],
			activityViewFilters,
			loggedUserCanAddActivities: false,
			loggedUserCanCloseActivities: false,
			loggedUserCanEditActivities: false,
		});
	}

	async insertFlashTaskBtn_clickHandler (event, data) {
		const flashTaskTextArea = event.target.closest("[data-flash-task-insert-box]").querySelector("textarea");

		if (flashTaskTextArea && flashTaskTextArea.value.trim() !== "") {
			const activityGuid = data.guid;
			const text = flashTaskTextArea.value;

			const flashTask = new Task({
				activityGuid: activityGuid,
				assigneeGuid: "",
				body: text.length > 128 ? text : "",
				createdByGuid: Shark.$store?.loggedUser?.guid,
				name: text.slice(0, 128),
				priority: 3,
				projectGuid: Shark.$store?.currProject.guid,
				status: 1,
			});

			console.log({flashTask});
			
			await taskManager.save(flashTask);

			flashTaskTextArea.value = "";
			event.target.closest("[data-flash-task-insert-box]")?.classList.remove("open");
			this.refreshList(Shark.$store.currProject.guid);
		}
	}

	async loadUserPermissions (projectGuid) {
		const { currProject } = Shark.get();
		const userPermissionResponse = await userPermissionManager.getActiveForUserByProjectGuid(projectGuid);
		console.log({userPermissionResponse});

		if (userPermissionResponse.data.length > 0) {
			const currProjectUserPermissions = userPermissionResponse.data[0];

			Shark.set({
				currProjectUserPermissions,
				loggedUserCanAddActivities: currProjectUserPermissions.hasPermission("addActivity"),
				loggedUserCanCloseActivities: currProjectUserPermissions.hasPermission("closeActivity"),
				loggedUserCanEditActivities: currProjectUserPermissions.hasPermission("editActivity"),
			});
		}
		else{
			Shark.set({
				loggedUserCanAddActivities: currProject.__userIsOwner,
				loggedUserCanCloseActivities: currProject.__userIsOwner,
				loggedUserCanEditActivities: currProject.__userIsOwner,
			});
		}
	}

	async refreshList (projectGuid) {
		waitBoxComponent.open();

		await this.loadUserPermissions(projectGuid);

		activityManager.getListByProjectGuid(projectGuid || Shark.$store?.currProject.guid, Shark.$store.activityViewFilters)
		.then(async response => {
			console.log({response});
			const { activityViewFilters } = Shark.get();
			const activityList = Shark.getInstanceList(Activity, response.data);

			activityList.forEach((item, index) => {
				item.__index = index;
				item.__displayIndex = index + 1;
				//Alla ricreazione delle list quando riassegno gli __shguid dovrei poi usarli per calcolare l'hash, se no non si accorge del reload... ma è tutto vero davvero?
				item.rnd = Math.random();
			});
			
			if (activityViewFilters.displayModeList) {
				Shark.set({
					activityList,
				});
			}
			else if (activityViewFilters.displayModeCards) {
				const taskFilters = {
					showOpenTask: true,
					showPriority1: true,
					showPriority2: true,
					showPriority3: true,
					showPriority4: true,
					showPriority5: true,
				};
				
				const taskListResponse = await taskManager.getListByActivityGuidList(activityList.map(item => item.guid), taskFilters);
				const taskList = Shark.getInstanceList(Task, taskListResponse.data);

				activityList.forEach(activity => {
					activity.__taskList = taskList.filter(task => task.activityGuid === activity.guid);
					// activity.__taskList.sort();
				});
					
				Shark.set({
					activityList,
					taskList,
					fullTaskList: taskList,
				});
				
				const groupName = "activities";
				
				document.querySelectorAll(".activityCard").forEach(item => {
					new Sortable(item, {
						group: groupName,
						animation: 150,
						// ghostClass: "blue-background-class"
						onEnd: async event => {
							console.log({event});
							console.log(event.item.dataset.guid);
							console.log(event.from.dataset.guid);
							console.log(event.to.dataset.guid);
							
							// Dave: devo fare un metodo lato API per gestire lo spostamento
							const { fullTaskList } = Shark.get();
							const taskToUpdate = Utils.safp(fullTaskList, "guid", event.item.dataset.guid);
							
							if (taskToUpdate) {
								if (event.to.dataset.guid !== taskToUpdate.activityGuid) {
									taskToUpdate.activityGuid = event.to.dataset.guid;		
									const saveResponse = await taskManager.save(taskToUpdate);
									
									if (saveResponse.status === "ok") {
										console.log("$cAggiornato!", "color: green; font-weight: bold;");
									}
								}
								else {
									const taskToUpdateList = [];
									const taskToUpdatePriority = taskToUpdate.priority;
									const samePriorityTaskList = Array.from(event.item.parentNode.children).filter(item => item.dataset.priority == taskToUpdatePriority);

									samePriorityTaskList.forEach(item => {
										const newSortPosition = samePriorityTaskList.indexOf(item);
										// const newSortPosition = Array.prototype.indexOf.call(event.item.parentNode.children, item);
										const itemTask = Utils.safp(fullTaskList, "guid", item.dataset.guid);

										if (itemTask) {
											itemTask.set({
												sortOrder: newSortPosition,
											});

											if (itemTask.sortOrder !== itemTask.__originalSortOrder) {
												taskToUpdateList.push(itemTask);
											}
										}
									});

									console.log({ taskToUpdateList });
									const saveResponse = await taskManager.save(taskToUpdateList);
									console.log({ saveResponse });
									
									Shark.render();
								}
							}
						},
					});
				});
			}
					
			waitBoxComponent.close();
		});
	}

	refresListBtn_clickHandler () {
		if (Shark.$store.currProject) {
			this.refreshList(Shark.$store.currProject.guid);
		}
	}

	rowFooter_mouseoverHandler (event) {
		const flashTaskInsertBox = event.target.parentNode.querySelector("[data-flash-task-insert-box]");

		if (flashTaskInsertBox) {
			flashTaskInsertBox.classList.add("open");
			flashTaskInsertBox.querySelector("[data-flash-task-insert-title]")?.focus();
		}
		
	}

	saveCurrActivity () {
		const { currActivity } = Shark.get();

		if (currActivity) {
			const errorList = currActivity.validate();

			if (errorList.length > 0) {
				alert("Si sono verificati i seguenti errori:\n\n" + errorList.join("\n"));
			}
			else {
				if (currActivity) {
					activityManager.save(currActivity)
					.then(response => {
						console.log(response);
						this.collapse.hide();
						this.refreshList();
					});
				}
			}
		}
	}

	// Non sono sicuro di volerlo fare.
	// saveOnReturnKeyField_keydownHandler (event) {
	// 	if (event.keyCode === 13) {
	// 		event.preventDefault();
	// 		event.stopPropagation();
			
	// 		this.saveCurrActivity();
	// 	}
	// }

	saveCurrActivityBtn_clickHandler () {
		this.saveCurrActivity();
	}
	
	setActivitySettings (activity) {
		activitySettingsComponent.open(activity);
	}

	setActivitySettingsBtn_clickHandler (event, data) {
		const { activityList } = Shark.get();
		const currActivity = Utils.safp(activityList, "guid", data.guid);

		if (currActivity) {
			this.setActivitySettings(currActivity);
		}
	}

	setHandScroll (elem) {
		const dragStart = (ev) => {
			if (!ev.target.classList.contains("hand-scroll")) {
				return;
			}
			elem.style.cursor = "grabbing";
			elem.setPointerCapture(ev.pointerId)
		};

		const dragEnd = (ev) => {
			elem.style.cursor = "";
			elem.releasePointerCapture(ev.pointerId)
		};

		const drag = (ev) => {
			elem.hasPointerCapture(ev.pointerId) && (elem.scrollLeft -= ev.movementX)
		};
		
		elem.addEventListener("pointerdown", dragStart);
		elem.addEventListener("pointerup", dragEnd);
		elem.addEventListener("pointermove", drag);
	};
}

const activityListView = new ActivityListView();

Shark.registerView(activityListView);

export default activityListView;
